import { LoanProductCategory } from '@mediaingenuity/totallymoney.types'

const metaDataResource: Record<
    LoanProductCategory,
    { canonical: string; description: string; title: string }
> = {
    ['PersonalLoan']: {
        title: 'Need a Loan? Compare Cheap UK Loans Online. Apply Today!',
        description:
            'Compare Loans Between £500 and £100,000 Even with Poor Credit History. Boost Your Chance of Acceptance for Loans with Our Fast Eligibility Check. Apply Today!',
        canonical: 'https://www.totallymoney.com/loans/',
    },
    ['PoorCredit']: {
        title: 'Poor Credit History? Compare Loans for People with Bad Credit!',
        description:
            'Compare Loans from Multiple Providers in One Quick Search. Find Your Likelihood of Acceptance Before Applying. Boost Your Chances of Approval. Apply Today!',
        canonical: 'https://www.totallymoney.com/loans/bad-credit/',
    },
    ['Secured']: {
        title: 'Compare Homeowner Loans. Check Eligibility - Apply Today!',
        description:
            'Compare Homeowner Loans Across the Whole Loans Market Boost Your Chance of Acceptance for a Loan with Our Fast Eligibility Check.',
        canonical: 'https://www.totallymoney.com/loans/homeowner/',
    },
    ['CarFinance']: {
        title: 'Compare Car Finance Loans. Check Eligibility Today!',
        description:
            'Compare Car Finance Loans. Boost Your Chance of Acceptance for a Loan with Our Fast Eligibility Check.',
        canonical: 'https://www.totallymoney.com/loans/car-finance/',
    },
    ['Guarantor']: {
        title: 'Compare Loans With a Guarantor. Check Eligibility - Apply Today!',
        description:
            'Compare Guarantor Loans from Multiple Providers in One Quick Search. Find Your Likelihood of Acceptance Before Applying. Apply Today!',
        canonical: 'https://www.totallymoney.com/loans/guarantor/',
    },
    ['AlternativeProducts']: {
        title: 'Need a Loan? Compare Cheap UK Loans Online. Apply Today!',
        description:
            'Compare Loans Between £500 and £100,000 Even with Poor Credit History. Boost Your Chance of Acceptance for Loans with Our Fast Eligibility Check. Apply Today!',
        canonical: 'https://www.totallymoney.com/loans/',
    },
}

const defaultResource = {
    title: 'Need a Loan? Compare Cheap UK Loans Online. Apply Today!',
    description:
        'Compare Loans Between £500 and £100,000 Even with Poor Credit History. Boost Your Chance of Acceptance for Loans with Our Fast Eligibility Check. Apply Today!',
    canonical: 'https://www.totallymoney.com/loans/',
}

export function getUnscoredCategoryMetadata(
    category: keyof typeof metaDataResource
) {
    return category ? metaDataResource[category] : defaultResource
}
